import { IGridSchema } from "ts/api/grid-schema";
import type { AssignedTaskFormValue } from "view/components/TasksList/types";

/**
 * GridPreview reads the grid schema off `task.gridSchema` and the saved
 * answer off `task.grid`. When `apiV2` is supplied the row carries neither,
 * so graft the schema and answer on (otherwise GridPreview maps an
 * undefined schema and crashes). Without `apiV2` the row keeps its inline
 * fields and only gets the resolved `dueDate` stamped.
 */
export const buildGridPreviewTask = (params: {
  task: AssignedTaskFormValue;
  gridDueDate: Date | null;
  apiV2?: { gridSchema?: IGridSchema | null };
  response?: AssignedTaskFormValue["grid"];
  // Names of exhibitor-added rows. The renderer reads added-row titles
  // (rowIndex >= schema rows) off `additionalRowNames`, NOT off the expanded
  // schema (which only grows the cell matrix), so they must be grafted on or
  // added rows render nameless in the preview.
  additionalRowNames?: AssignedTaskFormValue["additionalRowNames"];
}): AssignedTaskFormValue => {
  const { task, gridDueDate, apiV2, response, additionalRowNames } = params;
  const base = { ...task, dueDate: gridDueDate };
  if (!apiV2) return base;
  return {
    ...base,
    gridSchema: apiV2.gridSchema ?? task.gridSchema,
    grid: response ?? task.grid,
    additionalRowNames: additionalRowNames ?? task.additionalRowNames,
  };
};
